var render, staticRenderFns
import script from "./Placeholder.vue?vue&type=script&lang=js&"
export * from "./Placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\inetpub\\wwwroot\\eaist\\vue-treeselect\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a99d1f3')) {
      api.createRecord('5a99d1f3', component.options)
    } else {
      api.reload('5a99d1f3', component.options)
    }
    
  }
}
component.options.__file = "src/components/Placeholder.vue"
export default component.exports